import "./AboutUsImage.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const AboutUsImage = () => {
  const { t } = useTranslation();

  return (
    <div className="about-us-img">
      <Link to="/about" style={{color:'white'}}><img src={t("about_us_rounded_image")} alt="" /></Link>
      <div className="about_us_text">
        <p>{t("about_us_paragraph")}</p>
        <button><Link to="/about" style={{color:'white'}}>{t("more_button")}</Link></button>
      </div>
    </div>
  );
};

export default AboutUsImage;